// extracted by mini-css-extract-plugin
module.exports = {"row":"AccountListRow_row__3BNg3","name":"AccountListRow_name__y2j_J","balance":"AccountListRow_balance__BBfZK"};